import { IAppBaiVietSaveRequest } from "../models/request/app-bai-viet/IAppBaiVietSaveRequest";
import { IAppBaiVietSelectRequest } from "../models/request/app-bai-viet/IAppBaiVietSelectRequest";
import { app_baiviet } from "../models/response/app-phuhuynh/app_baiviet";
import { apiClient } from "./apiClient";
import { BaseCRUDApi } from "./baseCRUDApi";

export const API_APP_BAIVIET_PATH = "app-baiviet"

class AppBaiVietApi extends BaseCRUDApi<app_baiviet> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
    SelectBySchoolAsync(rq: IAppBaiVietSelectRequest) {
        return apiClient.post(`${API_APP_BAIVIET_PATH}/select`, rq)
    }
    SelectNhomBaiVietAsync() {
        return apiClient.get(`${API_APP_BAIVIET_PATH}/nhom`)
    }
    InsertModel(request: IAppBaiVietSaveRequest) {
        return apiClient.post(`${API_APP_BAIVIET_PATH}`, request)
    }
    UpdateModal(request: IAppBaiVietSaveRequest) {
        return apiClient.put(`${API_APP_BAIVIET_PATH}`, request)
    }
    SelectFiles(id: number) {
        return apiClient.get(`${API_APP_BAIVIET_PATH}/${id}/files`)
    }
    Delete(id: number) {
        return apiClient.delete(`${API_APP_BAIVIET_PATH}/${id}`)
    }
    Publish(id: number) {
        return apiClient.put(`${API_APP_BAIVIET_PATH}/${id}/publish`)
    }
    SelectReaction(id: number) {
        return apiClient.get(`${API_APP_BAIVIET_PATH}/${id}/reactions`)
    }
    SelectHocSinhs(id: number) {
        return apiClient.get(`${API_APP_BAIVIET_PATH}/${id}/students`)
    }
}
export const appBaiVietApi = new AppBaiVietApi({ path: API_APP_BAIVIET_PATH });